jQuery(document).ready(function($) {
  $('#site-navigation').hcOffcanvasNav({
    maxWidth: 800,
    position: 'right'
  });
});
